import { Transforms } from 'slate';
import { findLink } from '../queries/findLink.mjs';

function updateLink(editor, {
  text,
  entry = findLink(editor),
  data
}) {
  if (!entry) {
    return;
  }
  const [node, path] = entry;
  Transforms.setNodes(editor, {
    ...node,
    ...data
  }, {
    at: path
  });
  if (text) {
    Transforms.select(editor, path);
    Transforms.insertText(editor, text);
  }
}

export { updateLink };
